import { FormVmValueValidatorResultType } from '../../infrastructure/form-viewmodel-controller';
import { trimSpaces, trimSpacesLeft } from '../formatters';
import { plainText, requiredValidator, url } from '../validators';

export const LABEL = 'label';
export const URL = 'url';
export const TYPE = 'Type';

const validatorsOverrides = {
    plainText: {
        ...plainText,
        required: (...args: string[]): FormVmValueValidatorResultType => {
            const descriptor = { id: 'oe.validation.required.message', defaultMessage: '{fieldName} is required.' };
            const result = requiredValidator(...args);

            if (!result.valid) result.validationMessage = descriptor;

            return result;
        },
    }
};

export const EventLinkConfig = {
    [LABEL]: {
        labelDescriptor: { id: `oe.input.label.${LABEL}`, defaultMessage: 'Label' },
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [URL]: {
        labelDescriptor: { id: `oe.input.label.${URL}`, defaultMessage: 'URL' },
        defaultValue: '',
        validators: [validatorsOverrides.plainText.required, validatorsOverrides.plainText.maxLength.medium, url.regExp],
        formatters: [trimSpaces]
    }
};

export default Object
    .entries(EventLinkConfig)
    .map(([key, cnf]) => ({ name: key, ...cnf }))
    ;
